import { useSelector } from 'react-redux';

import { formatNumberAndCents } from '@makemydeal/dr-common-utils';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { ReadOnlyLinkRow } from '../../ReadOnlyLinkRow';

export const FeesRow = () => {
    const totalFees = useSelector(offerReduxSelectors.getTotalFee);

    return <ReadOnlyLinkRow rowKey="fees" label="Fees" value={formatNumberAndCents(totalFees)} tab={DealTabs.FEES} />;
};
